import React from 'react';
import BrandLogo from '../BrandLogo';
import Util from '../../util';

export default function Footer() {
	return (
		<footer className="footer-container d-flex flex-d-column">
			<div className="d-flex flex-d-column justify-content-end">
				<BrandLogo />
				<p>Copyright © 2020. {Util.BRAND_NAME}</p>
			</div>
		</footer>
	);
}
